import { createRouter, createWebHistory } from 'vue-router'
import HomePage from './views/HomePage.vue'
import { applyRouteSeo } from './utils/seo'

const AboutPage = () => import('./views/AboutUsPage.vue')
const chat = () => import('./components/QuickChat.vue')
const RoofingPage = () => import('./views/PhotoGallery/RoofingPage.vue')
const RepairsPage = () => import('./views/PhotoGallery/RepairsPage.vue')
const SidingPage = () => import('./views/PhotoGallery/SidingPage.vue')
const GutterPage = () => import('./views/PhotoGallery/GutterPage.vue')
const FasciaSoffet = () => import('./views/PhotoGallery/FasciaSoffet.vue')
const GaylordPage = () => import('./views/Locations/GaylordPage.vue')
const NotFoundPage = () => import('./views/NotFoundPage.vue')

const routes = [
  {
    path: '/',
    name: 'Home',
    component: HomePage,
    meta: {
      breadcrumb: 'Home',
      seo: {
        title: 'Roofing Contractor Niles MI | Roof Replacement & Repair | Homes Roofing Co LLC',
        shortTitle: 'Niles MI Roofing Contractor',
        description: "Homes Roofing Co LLC is Niles, MI's licensed roofing contractor (#252400025). Specializing in tear-offs, storm damage repair, and 50-year warranty installations across Berrien & Cass counties. Call (269) 262-5055 for a free estimate.",
        keywords: 'Michigan roofing contractor, Niles MI roofing contractor, roof repair Niles MI, roof replacement Berrien County, storm damage repair Niles Michigan, Gaylord roof repair',
        canonicalPath: '/',
        type: 'website',
        schemaType: 'WebPage'
      }
    }
  },
  {
    path: '/about',
    name: 'About',
    component: AboutPage,
    meta: {
      breadcrumb: 'About',
      seo: {
        title: 'About Homes Roofing Co | Licensed Roofing Contractor in Michigan',
        shortTitle: 'About Homes Roofing Co',
        description: 'Learn about Homes Roofing Co, a licensed and insured roofing contractor serving homeowners across Michigan with roof replacement, repair, fascia, soffit, and gutter services.',
        keywords: 'about roofing contractor Michigan, licensed roofer Michigan, Gaylord roof repair company, Niles Michigan roofer',
        canonicalPath: '/about',
        type: 'article',
        schemaType: 'AboutPage'
      }
    }
  },
  {
    path: '/roofing-projects',
    name: 'RoofingProjects',
    component: RoofingPage,
    meta: {
      breadcrumb: 'Roofing Projects',
      seo: {
        title: 'Roof Replacement Projects in Michigan | Homes Roofing Co',
        shortTitle: 'Roof Replacement Projects',
        description: 'Browse roof replacement projects completed by Homes Roofing Co for homeowners across Michigan, with trusted workmanship, durable materials, and long-term warranties.',
        keywords: 'roof replacement Michigan, roofing projects Michigan, new roof Gaylord Michigan, roofing contractor portfolio',
        canonicalPath: '/roofing-projects',
        type: 'article'
      }
    }
  },
  {
    path: '/repair-projects',
    name: 'RepairProjects',
    component: RepairsPage,
    meta: {
      breadcrumb: 'Roof Repair',
      seo: {
        title: 'Gaylord Roof Repair | Emergency Roof Repair in Michigan | Homes Roofing Co',
        shortTitle: 'Gaylord Roof Repair',
        description: 'Need Gaylord roof repair? Homes Roofing Co provides emergency roof repair and dependable roofing service for homeowners in Gaylord, Michigan and across the Great Lakes State.',
        keywords: 'Gaylord roof repair, roof repair Gaylord MI, Gaylord Michigan roofing, emergency roof repair Michigan, Gaylod roof repair',
        canonicalPath: '/repair-projects',
        type: 'article'
      }
    }
  },
  {
    path: '/gaylord-roof-repair',
    alias: ['/gaylord-roofing', '/gaylord'],
    name: 'GaylordRoofRepair',
    component: GaylordPage,
    meta: {
      breadcrumb: 'Gaylord Roof Repair',
      seo: {
        title: 'Roofing Contractor Gaylord MI | Cold-Climate Roofs & Ice Dam Repair | Homes Roofing Co LLC',
        shortTitle: 'Gaylord MI Roofing Contractor',
        description: 'Trusted roofing contractor in Gaylord & Otsego County. Specializing in heavy snow load roofing, ice dam prevention, storm repair, and tear-offs. Call (989) 858-3559 for a free inspection.',
        keywords: 'Gaylord roofing contractor, ice dam repair Gaylord MI, cold climate roofing Michigan, Otsego County roofing, heavy snow load roof repair, storm damage repair Gaylord',
        canonicalPath: '/gaylord-roof-repair',
        type: 'article',
        schemaType: 'WebPage'
      }
    }
  },
  {
    path: '/siding-services',
    name: 'SidingServices',
    component: SidingPage,
    meta: {
      breadcrumb: 'Siding Services',
      seo: {
        title: 'Siding Services in Michigan | Homes Roofing Co',
        shortTitle: 'Siding Services',
        description: 'Homes Roofing Co offers siding services for homeowners across Michigan, helping protect and refresh homes with durable exterior solutions.',
        keywords: 'siding services Michigan, siding contractor Michigan, exterior repair Michigan, siding installation Gaylord Michigan',
        canonicalPath: '/siding-services',
        type: 'article'
      }
    }
  },
  {
    path: '/fascia-soffit',
    name: 'FasciaSoffit',
    component: FasciaSoffet,
    meta: {
      breadcrumb: 'Fascia & Soffit',
      seo: {
        title: 'Fascia and Soffit Services in Michigan | Homes Roofing Co',
        shortTitle: 'Fascia and Soffit',
        description: 'Protect your home with fascia and soffit repair and installation from Homes Roofing Co, serving homeowners across Michigan with quality exterior work.',
        keywords: 'fascia and soffit Michigan, soffit repair Michigan, fascia installation Michigan, exterior trim repair Gaylord',
        canonicalPath: '/fascia-soffit',
        type: 'article'
      }
    }
  },
  {
    path: '/gutter-services',
    name: 'GutterServices',
    component: GutterPage,
    meta: {
      breadcrumb: 'Gutter Services',
      seo: {
        title: 'Gutter Services in Michigan | Homes Roofing Co',
        shortTitle: 'Gutter Services',
        description: 'Homes Roofing Co provides gutter installation and exterior water-management services for homeowners across Michigan.',
        keywords: 'gutter services Michigan, gutter installation Michigan, gutter contractor Gaylord Michigan, seamless gutters Michigan',
        canonicalPath: '/gutter-services',
        type: 'article'
      }
    }
  },
  {
    path: '/chat',
    name: 'Chat',
    component: chat,
    meta: {
      seo: {
        title: 'Chat | Homes Roofing Co',
        shortTitle: 'Chat',
        description: 'Contact Homes Roofing Co for help with your roofing questions.',
        keywords: 'roofing contact Michigan, roofing estimate Michigan',
        canonicalPath: '/chat',
        robots: 'noindex, nofollow',
        type: 'website'
      }
    }
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: NotFoundPage,
    meta: {
      seo: {
        title: 'Page Not Found | Homes Roofing Co',
        shortTitle: 'Page Not Found',
        description: 'The page you are looking for could not be found.',
        keywords: 'homes roofing',
        canonicalPath: '/',
        robots: 'noindex, nofollow',
        type: 'website'
      }
    }
  }

]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
      return { top: 0 }
    }
  })

router.afterEach((to) => {
  applyRouteSeo(to)
})


export default router